import Vue from 'vue';
import Sidenav from '../modules/common/components/Sidenav';

Vue.component('sidenav', Sidenav);